import React from 'react';
import { ApiButton, Button, DialogActions, DialogContent, DialogContentText, DialogTitle } from 'web-library';
import { Dialog } from '@mui/material';

interface ENetsModalProps {
  modelOpen: boolean;
  onClose: () => void;
  onClickCheckout: () => void;
}

const ENetsModal = ({ modelOpen, onClose, onClickCheckout }: ENetsModalProps) => (
        <Dialog open={modelOpen} maxWidth="sm">
            <DialogTitle>Pay with Credit/Debit Card</DialogTitle>

            <DialogContent>
                <DialogContentText>
                    Before you begin, please enable pop-ups in your web browser and do not close or refresh this
                    window while in the process of payment. When the &quot;Make Payment&quot; button below is
                    clicked, an external window will appear for you to make your payment. Once you have made
                    your payment, please return to this window for your receipt.
                </DialogContentText>
            </DialogContent>

            <DialogActions>
                <Button
                    type="button"
                    variant="text"
                    onClick={onClose}
                >
                    Cancel
                </Button>
                <ApiButton
                    id="button-enetsModal-makePayment"
                    type="button"
                    status="idle"
                    onClick={onClickCheckout}
                >
                    Make Payment
                </ApiButton>
            </DialogActions>
        </Dialog>
);


export default ENetsModal;
